/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import cn from 'classnames';
import { Layout, Localization, Typography } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { useFormatStatusEventDateTime } from '../useFormatStatusEventDateTime';

const { Translate } = Localization;
const { Subtitle } = Typography;

const Styled = styled(Layout.Container)``;

const UnloadingPointDesktop = ({
  className,
  deliveryAddress,
  mapsDirectionsHref,
  siteContact,
  ticket,
  unloading,
  arriveJob,
  endUnloading,
  isStandAloneTicket,
}) => {
  const formatTicketDateTime = useFormatStatusEventDateTime({ mode: 'datetime' });

  return (
    <Styled className={cn('unloading-point', className)}>
      <Subtitle>
        <Translate stringId="unloadingPoint" data-testid="unloadingPointLabel" />
      </Subtitle>
      <div>
        <Translate stringId="siteAddress" data-testid="siteAddressLabel" /> :{' '}
        <span data-testid="deliveryAddressValue">{deliveryAddress}</span>{' '}
        {mapsDirectionsHref && isStandAloneTicket && (
          <a
            href={mapsDirectionsHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="getDirectionsLink"
          >
            <Translate stringId="getDirections" data-testid="getDirectionsLabel" />
          </a>
        )}
      </div>
      <div>
        <Translate stringId="customer" data-testid="customerLabel" /> :{' '}
        <span data-testid="customerName">
          {ticket?.customerParty?.id}/{ticket?.customerParty?.name}
        </span>
      </div>

      <div>
        <Translate stringId="siteContactName" data-testid="siteContactNameLabel" /> :{' '}
        <span data-testid="siteContactName">{siteContact?.name}</span>
      </div>
      <div>
        <Translate stringId="siteContactPhoneNumber" data-testid="customerPhoneNumberLabel" /> :{' '}
        <span data-testid="customerPhoneNumber">
          {' '}
          <a href={`tel:${siteContact?.phone}`}>{siteContact?.phone}</a>{' '}
        </span>
      </div>
      {ticket?.customData?.ticketType !== 'PMP' && (
        <div>
          <Translate stringId="unloadingScheduleStart" data-testid="unloadingScheduleStartLabel" />
          {': '}
          <span style={{ whiteSpace: 'nowrap' }} data-testid="unloadingScheduleStart">
            {formatTicketDateTime(unloading)}
          </span>
        </div>
      )}
      <div>
        <Translate stringId="agreedUnloading" data-testid="agreedUnloadingLabel" />
        {': '}
        <span style={{ whiteSpace: 'nowrap' }} data-testid="agreedUnloading">
          {formatTicketDateTime(arriveJob)}
          {' - '}
          {formatTicketDateTime(endUnloading)}
        </span>
      </div>
    </Styled>
  );
};

export default UnloadingPointDesktop;
